//initialState
const initialState = {
    arrQuestions: [],
    name: 'QUIZ'
};

export default initialState;